import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'
import { rem } from 'polished'

import { RADIUS_1 } from '@Styles/constants/radius'

export const odSearchExternalHeader = (theme: Theme): SerializedStyles =>
  css({
    alignContent: 'center',
    backgroundColor: theme.customPalette.background.main,
    borderRadius: `${RADIUS_1} ${RADIUS_1} 0 0`,
    color: theme.palette.primary.contrastText,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    height: rem(80),
    padding: theme.spacing('0', 1),
    position: 'relative',
    zIndex: 0,
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing('0', 2),
    },
  })

export const brandIcon = css({
  height: rem(54),
  width: 'auto',
})
